import { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../services/AuthContext";
import { Alert, Button, Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap";
import CartResume from "../../components/cart/CartResume";
import { fetchCityListData, fetchProvinceListData } from "../../services/GeoServices";
import { createOrder } from "../../services/OrderServices";
import { getShippingData } from "../../services/ShippingServices";
import { usePage } from "../../services/PageContext";
import { Editor } from '@tinymce/tinymce-react';
import { TINY_APP } from "../../Config";
import { useNavigate } from "react-router-dom";

export default function Checkout() {
  const [validated, setValidated] = useState(false);
  const { user, isAuthenticated, updateOrder, updateCart } = useContext(AuthContext);
  const [ shippingData, setShippingData ] = useState({province_id: 0});
  const [ provinces, setProvinces ] = useState([]);
  const [ cities, setCities ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const [ visible, setVisible ] = useState(false);
  const [ message, setMessage ] = useState('');
  const { isMobileStyle } = usePage()
  const editorRef = useRef(null);
  const navigate = useNavigate()

  if (!isAuthenticated) {
    navigate("/");
  }
  
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity()) {
      newOrder();
    } else {
      setVisible(true);
      setMessage('Falta completar el formulario.')
    }

    setValidated(true);
  };

  useEffect(()=>{
    const client = user.isSeller ? user.clientSelected : user.id;
    getShippingData({id: client})
      .then((data) => {
        setShippingData({
          ...shippingData, 
          province_id: Number(data.provincia_id),
          city_id:  Number(data.ciudad_id),
          address: data.direccion,
          transporte: data.transporte
        })
      })
  }, [user]);

  useEffect(()=>{
    if (shippingData.province_id > 0) {
      fetchCityListData(shippingData.province_id)
      .then((data) => {
        setCities(data);
      })
      .catch(err => console.log(err))
      .finally(() => {setLoading(false)});
    }
  },[shippingData.province_id])

  useEffect(() => {
    window.scrollTo(0,0);
    fetchProvinceListData()
      .then((data) => {
        setProvinces(data);
      })
      .catch(err => console.log(err))
  }, []);

  const newOrder = async () => {
    var f = new FormData();
    f.append("direccion", shippingData.address);
    f.append("provincia_id", shippingData.province_id);
    f.append("ciudad_id", shippingData.city_id);
    if (user.isSeller && user.clientSelected) {
      f.append("cliente_id", user.clientSelected);
    }
    if (shippingData.transporte) {
      f.append("transporte", shippingData.transporte);
    }
    if (editorRef.current.getContent()) {
      f.append("observaciones", editorRef.current.getContent());
    }
  
    setLoading(true);
    createOrder(f, {user: user.id})
      .then((data) => {
        setVisible(false);
        updateOrder(data.data)
        updateCart([]);
        navigate("/pedido-confirmado")
      })
      .catch((err) => {
        setVisible(true);
        setMessage(err.response.data);
      })
      .finally(() => {setLoading(false)}); 
  }

  return (
    <>
      <div className={`purple-header ${isMobileStyle ? 'is-mobile' : ''}`}>
        <div className='content'>
          <div className='title'>Datos de envío</div>
          <div className='subtitle'>Ingresa los datos de envío y confirmá tu pedido</div>
        </div>
      </div>
      <div className='cart-container'>
        <div className="content">
          {loading ?
            <div className='content-loading'>
              <Spinner variant="success" />
            </div>
            :
            <>
              <Alert variant="danger" dismissible show={visible} onClose={() => setVisible(false)}>
                {message}
              </Alert>
              <div className='cart-details'>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group as={Col} controlId="formGridState">
                        <FloatingLabel
                          controlId="floatingState"
                          label="Provincia"
                          className="mb-3"
                        >
                          <Form.Select
                            required
                            value={shippingData.province_id}
                            onChange={(e) => {
                              setShippingData({
                                ...shippingData, 
                                province_id: Number(e.target.value),
                                city_id: 0
                              })
                            }}>
                            <option></option>
                            {provinces.length > 0 && 
                              provinces.map((item) => {
                                return <option key={`prov_${item.id}`} value={item.id}>{item.nombre}</option>
                              })
                            }
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Debe elegir una provincia.
                          </Form.Control.Feedback>
                        </FloatingLabel>
                      </Form.Group>

                      <Form.Group as={Col} controlId="formGridCity">
                        <FloatingLabel controlId="floatingCity" label="Ciudad">
                        <Form.Select
                          required
                          value={shippingData.city_id}
                          onChange={(e) => {
                            setShippingData({
                              ...shippingData, 
                              city_id: Number(e.target.value)
                            })
                          }}
                          disabled={shippingData.province_id == 0}>
                            <option></option>
                            {cities.length > 0 && 
                              cities.map((item) => {
                                return <option key={`city_${item.id}`} value={item.id}>{item.nombre}</option>
                              })
                            }
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Debe elegir una ciudad.
                          </Form.Control.Feedback>
                        </FloatingLabel>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group as={Col} controlId="formGridName">
                        <FloatingLabel
                          controlId="floatingName"
                          label="Dirección de Envío"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder='Dirección de envío'
                            value={shippingData.address}
                            onChange={(e) => {
                              setShippingData({
                                ...shippingData,
                                address: e.target.value,
                              });
                            }}
                            required/>
                          <Form.Control.Feedback type="invalid">
                            Ingresa una dirección.
                          </Form.Control.Feedback>
                        </FloatingLabel>
                      </Form.Group>
                      <Form.Group as={Col} controlId="formShipping">
                        <FloatingLabel
                          controlId="floatinShipping"
                          label="Transporte"
                          className="mb-3"
                        >
                          <Form.Control
                            type="text"
                            placeholder=''
                            value={shippingData.transporte}
                            onChange={(e) => {
                              setShippingData({
                                ...shippingData,
                                transporte: e.target.value,
                              });
                            }}
                            />
                        </FloatingLabel>
                      </Form.Group>
                    </Row>
                    <Row className="mb-5">
                      <Editor
                        apiKey={TINY_APP}
                        onInit={ (_evt, editor) => editorRef.current = editor }
                        init={{
                          height: 200,
                          menubar: false,
                          plugins: [
                            // Core editing features
                            'anchor', 'autolink', 'charmap', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount',
                          ],
                          toolbar: 'undo redo | bold italic link | bullist numlist outdent indent | removeformat',
                          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                      />
                    </Row>
                    <div className="btn-content left">
                      <Button type='submit' variant="third">Confirmar Compra</Button>
                    </div>
                  </Form>
              </div>
              <CartResume shippingMode={true}/>
            </>
          }
        </div>
      </div>
    </>
  )
}